/*const selectors = {
    dropdowns: "[data-menu-dropdown]",
    dropdownList: "[data-menu-dropdown-list]",
    mobileMenuTrigger: "[data-trigger-burger-open]",
    mobileMenuBack: "[data-mobile-menu-back]",
    megaMenuPage: ".mega-menu",
    headerParent: "[data-trigger-burger-close]",
    subTrigger: "[data-menu-sub-trigger]",
    mobileSubTrigger: "[data-menu-mobile-sub-trigger]",
    subList: "[data-menu-sub-list]",
    announcementBar: "#shopify-section-announcement-bar",
    headerWrapper: "#shopify-section-header .header",
    menuWrapper: "#shopify-section-header nav.header__inline-menu",
};
class MegaMenu {
    constructor() {
        (this.lockBody = () => {
            (this.currentScrollTop = window.pageYOffset),
                this.setMenuHeight(),
                document.body.classList.add("locked"),
                (document.body.style.top = `-${this.currentScrollTop}px`),
                document.documentElement.style.setProperty("scroll-behavior", "auto");
        }),
            (this.unlockBody = () => {
                document.body.classList.remove("locked"),
                    (document.body.style.top = ""),
                    requestAnimationFrame(() => {
                        window.scrollTo(0, this.currentScrollTop), document.documentElement.style.removeProperty("scroll-behavior");
                    });
            }),
            (this.initMegaMenu = () => {
                this.setMenuHeight(),
                    (window.onresize = () => {
                        this.setMenuHeight();
                    });
                let a = document.querySelector(selectors.mobileMenuTrigger),
                    d = document.querySelectorAll(selectors.megaMenuPage);
                a &&
                    a.addEventListener("click", () => {
                        a.hasAttribute("open")
                            ? (this.unlockBody(),
                           
                              document.querySelector("header").classList.remove("mobile-menu-open"),
                              (document.querySelector("sticky-header").isOpen = !1),
                              requestAnimationFrame(document.querySelector("sticky-header").hide),
                              [...d].forEach((a) => a.classList.remove("active")))
                            : (this.lockBody(),
                              (document.querySelector("sticky-header").isOpen = !0),
                              requestAnimationFrame(document.querySelector("sticky-header").reveal),
                              document.querySelector("header").classList.add("mobile-menu-open"));
                      
                         
                    });
                let b = document.querySelectorAll(selectors.mobileMenuBack);
                b &&
                    [...b].forEach((a) =>
                        a.addEventListener("click", () => {
                            [...d].forEach((a) => {
                                a.classList.contains("active") &&
                                    (a.classList.add("closing"),
                                    setTimeout(() => {
                                        a.classList.remove("active"), a.classList.remove("closing");
                                     $(".mega-menu-page__link-item--children [data-mobile-menu-back-child]").trigger("click");
                                     
                                      $("body").find('.cstm-jqu-jtpl').removeClass('opned-jtpl');
                                     
                                    }, 300));
                               
                            });
                        })
                    );
                let c = document.querySelectorAll(selectors.dropdowns);
                [...c].forEach((a) => {
                    let b = a.parentElement,
                        c = b.querySelectorAll(selectors.subTrigger),
                        d = b.querySelectorAll(selectors.mobileSubTrigger),
                        e = b.querySelectorAll(selectors.subList);
                    a.addEventListener("click", (a) => {
                        let b = a.currentTarget.parentElement;
                        b.classList.toggle("active"), this.resetTriggers(c, e, d);
                    }),
                        c.length &&
                            (c.forEach((a) =>
                                a.addEventListener("click", () => {
                                    let d = a.dataset.menuSubTrigger,
                                        b = e[d];
                                    "false" === b.dataset.menuSubActive &&
                                        (c.forEach((a) => (a.dataset.menuSubActive = "false")), e.forEach((a) => (a.dataset.menuSubActive = "false")), (b.dataset.menuSubActive = "true"), (a.dataset.menuSubActive = "true"));
                                })
                            ),
                            a.addEventListener("mouseover", (a) => {
                                this.resetTriggers(c, e, d);
                            })),
                        d.length &&
                            d.forEach((a) =>
                                a.addEventListener("click", () => {
                                    let c = a.dataset.menuMobileSubTrigger,
                                        b = e[c];
                                    "false" === b.dataset.menuSubActive
                                        ? (d.forEach((a) => (a.dataset.menuMobileSubActive = "false")), e.forEach((a) => (a.dataset.menuSubActive = "false")), (b.dataset.menuSubActive = "true"), (a.dataset.menuMobileSubActive = "true"))
                                        : "true" === b.dataset.menuSubActive && (d.forEach((a) => (a.dataset.menuMobileSubActive = "false")), e.forEach((a) => (a.dataset.menuSubActive = "false")));
                                })
                            );
                });
            }),
            (this.resetTriggers = (b, c, a) => {
                b.forEach((a) => (a.dataset.menuSubActive = "false")),
                    c.forEach((a) => (a.dataset.menuSubActive = "false")),
                    window.innerWidth >= 750 && ((b[0].dataset.menuSubActive = "true"), (c[0].dataset.menuSubActive = "true")),
                    a && (a.forEach((a) => (a.dataset.menuMobileSubActive = "false")), window.innerWidth > 750 && (a[0].dataset.menuMobileSubActive = "true"));
            }),
            (this.setMenuHeight = () => {
                let d = document.querySelector(selectors.announcementBar),
                    e = document.querySelector(selectors.headerWrapper),
                    a = d.clientHeight,
                    b = e.clientHeight,
                    c = window.innerHeight - b;
                0 === this.currentScrollTop ? (c = window.innerHeight - a - b) : a > this.currentScrollTop && (c = window.innerHeight - (a - this.currentScrollTop) - b), document.documentElement.style.setProperty("--menu-height", `${c}px`);
            });
    }
}
document.addEventListener("DOMContentLoaded", () => {
    let a = new MegaMenu();
    a.initMegaMenu();
});*/
const selectors = {
    dropdowns: "[data-menu-dropdown]",
    dropdownList: "[data-menu-dropdown-list]",
    mobileMenuTrigger: "[data-trigger-burger-open]",
    mobileMenuBack: "[data-mobile-menu-back]",
    megaMenuPage: ".mega-menu",
    headerParent: "[data-trigger-burger-close]",
    subTrigger: "[data-menu-sub-trigger]",
    mobileSubTrigger: "[data-menu-mobile-sub-trigger]",
    subList: "[data-menu-sub-list]",
    announcementBar: "#shopify-section-announcement-bar",
    headerWrapper: "#shopify-section-header .header",
    menuWrapper: "#shopify-section-header nav.header__inline-menu"
};
class MegaMenu {
    constructor() {
        this.lockBody = () => {
            this.currentScrollTop = window.pageYOffset, this.setMenuHeight(), document.body.classList.add("locked"), document.body.style.top = `-${this.currentScrollTop}px`, document.documentElement.style.setProperty("scroll-behavior", "auto")
        }, this.unlockBody = () => {
            document.body.classList.remove("locked"), document.body.style.top = "", requestAnimationFrame(() => {
                window.scrollTo(0, this.currentScrollTop), document.documentElement.style.removeProperty("scroll-behavior")
            })
        }, this.initMegaMenu = () => {
            this.setMenuHeight(), window.onresize = () => this.setMenuHeight();
            let mobileMenuTrigger = document.querySelector(selectors.mobileMenuTrigger),
                megaMenuPages = document.querySelectorAll(selectors.megaMenuPage);
            mobileMenuTrigger && mobileMenuTrigger.addEventListener("click", () => {
                mobileMenuTrigger.hasAttribute("open") ? (this.unlockBody(), document.querySelector("header").classList.remove("mobile-menu-open"), document.querySelector("sticky-header").isOpen = !1, requestAnimationFrame(document.querySelector("sticky-header").hide), [...megaMenuPages].forEach(page => page.classList.remove("active"))) : (this.lockBody(), document.querySelector("sticky-header").isOpen = !0, requestAnimationFrame(document.querySelector("sticky-header").reveal), document.querySelector("header").classList.add("mobile-menu-open"))
            }), document.querySelectorAll(selectors.mobileMenuBack).forEach(button => {
                button.addEventListener("click", () => {
                    [...megaMenuPages].forEach(page => {
                        page.classList.contains("active") && (page.classList.add("closing"), setTimeout(() => {
                            page.classList.remove("active"), page.classList.remove("closing"), $(".mega-menu-page__link-item--children [data-mobile-menu-back-child]").trigger("click"), $("body").find(".cstm-jqu-jtpl").removeClass("opned-jtpl")
                        }, 300))
                    })
                })
            });
            let dropdowns = document.querySelectorAll(selectors.dropdowns);
            [...dropdowns].forEach(dropdown => {
                let parent = dropdown.parentElement,
                    subTriggers = parent.querySelectorAll(selectors.subTrigger),
                    mobileSubTriggers = parent.querySelectorAll(selectors.mobileSubTrigger),
                    subLists = parent.querySelectorAll(selectors.subList);
              
                dropdown.addEventListener("click", e => {
                    let targetParent = e.currentTarget.parentElement;
                    [...dropdowns].forEach(item => {
                        let otherParent = item.parentElement;
                       // otherParent !== targetParent && otherParent.classList.remove("active")
                      //otherParent.classList.add("open");
                      if (otherParent !== targetParent && otherParent.classList.contains("active")) {
                          otherParent.classList.remove("active");
                      }
                     setTimeout(function(){                      
                       if($(".mega-menu.dsktop-mnu-jtpl").hasClass("active") == false){ 
                        otherParent.classList.remove("open");
                       }else{
                          otherParent.classList.add("open");
                       }
                     },500) ;
                    }), targetParent.classList.toggle("active"), this.resetTriggers(subTriggers, subLists, mobileSubTriggers)
                  
                  
                  
                }), subTriggers.forEach(trigger => {
                    trigger.addEventListener("click", () => {
                        let subMenuIndex = trigger.dataset.menuSubTrigger,
                            submenu = subLists[subMenuIndex];
                        submenu.dataset.menuSubActive === "false" && (subTriggers.forEach(trigger2 => trigger2.dataset.menuSubActive = "false"), subLists.forEach(list => list.dataset.menuSubActive = "false"), submenu.dataset.menuSubActive = "true", trigger.dataset.menuSubActive = "true")
                    })
                }), mobileSubTriggers.forEach(trigger => {
                    trigger.addEventListener("click", () => {
                        let subMenuIndex = trigger.dataset.menuMobileSubTrigger,
                            submenu = subLists[subMenuIndex];
                        submenu.dataset.menuSubActive === "false" ? (mobileSubTriggers.forEach(trigger2 => trigger2.dataset.menuMobileSubActive = "false"), subLists.forEach(list => list.dataset.menuSubActive = "false"), submenu.dataset.menuSubActive = "true", trigger.dataset.menuMobileSubActive = "true") : (mobileSubTriggers.forEach(trigger2 => trigger2.dataset.menuMobileSubActive = "false"), subLists.forEach(list => list.dataset.menuSubActive = "false"))
                    })
                })
            })
        }, this.resetTriggers = (subTriggers, subLists, mobileSubTriggers) => {
           setTimeout(function(){                      
                       if($(".mega-menu.dsktop-mnu-jtpl").hasClass("active") == false){ 
                        $("sticky-header.header-wrapper").removeClass("active");
                       }
                     },100) ;
          
            subTriggers.forEach(trigger => trigger.dataset.menuSubActive = "false"), subLists.forEach(list => list.dataset.menuSubActive = "false"), window.innerWidth >= 750 && (subTriggers[0].dataset.menuSubActive = "true", subLists[0].dataset.menuSubActive = "true"), mobileSubTriggers && (mobileSubTriggers.forEach(trigger => trigger.dataset.menuMobileSubActive = "false"), window.innerWidth > 750 && (mobileSubTriggers[0].dataset.menuMobileSubActive = "true"))
        }, this.setMenuHeight = () => {
            let announcementBar = document.querySelector(selectors.announcementBar),
                headerWrapper = document.querySelector(selectors.headerWrapper),
                announcementHeight = announcementBar.clientHeight,
                headerHeight = headerWrapper.clientHeight,
                availableHeight = window.innerHeight - headerHeight;
            this.currentScrollTop === 0 ? availableHeight = window.innerHeight - announcementHeight - headerHeight : announcementHeight > this.currentScrollTop && (availableHeight = window.innerHeight - (announcementHeight - this.currentScrollTop) - headerHeight), document.documentElement.style.setProperty("--menu-height", `${availableHeight}px`)
        }
    }
}
document.addEventListener("DOMContentLoaded", () => {
    new MegaMenu().initMegaMenu()
});


